export default __webpack_public_path__ + "assets/images/bitumen_bf2666546354457d0b017c246b62347f.jpg";